// Frans (fr-FR), timePicker: zelfde vorm als timePicker.nl.ts. Duur als "1 h", "1½ h", "1 h 15 min".
export const appTimePickerFr = {
    open: '{label} : choisir l’heure',
    hourStep: 'Choisis l’heure',
    minuteStep: 'Choisis les minutes',
    hours: 'Heures',
    minutes: 'Minutes',
    showNight: 'Nuit 00–05',
    back: 'Autre heure',
    close: 'Fermer',
    type: 'Saisir au clavier',
    invalid: 'Ce n’est pas une heure. Tape par exemple 15:30 ou 930.',
    beforeStart: 'Choisis une heure après {start}.',
    endClamped: 'Heure de fin ramenée à 23:59.',
    durations: 'Combien de temps ?',
    orPickEnd: 'Ou choisis une heure de fin',
    durationUntil: '{duration}, jusqu’à {time}',
    minutesShort: '{count} min',
    hoursShort: { one: '{count} h', other: '{count} h' },
};
//# sourceMappingURL=timePicker.fr.js.map